import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import search_utils from "ulysses/widgets/search/utils";
import markup from "ulysses/widgets/dashboard/dashboard.html";
import m_il from "ulysses/widgets/dashboard/dashboard-indicatorlist.html";
import m_i from "ulysses/widgets/dashboard/dashboard-indicator.html";
import m_c from "ulysses/widgets/dashboard/dashboard-chart.html";
import m_s from "ulysses/widgets/dashboard/dashboard-static.html";
import configure_dashboard from "ulysses/widgets/dashboard/editing";

"use strict";
$(document).ready(function() { $(markup+m_il+m_i+m_c+m_s).appendTo($("body")); });

var css_classes = {
    "1": "col col-xs-12",
    "2": "col col-xs-12 col-sm-6",
    "3": "col col-xs-12 col-sm-4",
    "4": "col col-xs-12 col-sm-6 col-md-3",
    "6": "col col-xs-12 col-sm-6 col-md-4 col-lg-4 col-vlg-2"
};
var derived_classes = {
    "3": {
        "2": "col col-xs-12 col-sm-8"
    },
    "4": {
        "2": "col col-xs-12 col-sm-6",
        "3": "col col-xs-12 col-sm-6 col-md-9"
    },
    "6": {
        "2": "col col-xs-12 col-sm-6 col-md-4 col-lg-4 col-vlg-4",
        "3": "col col-xs-12 col-sm-6",
        "4": "col col-xs-12 col-sm-6 col-md-8",
        "5": "col col-xs-12 col-sm-6 col-md-8 col-vlg-10"
    }
};


ko.bindingHandlers.dashboard_widget = {
    "init": function(elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        widget_model.settings_menu.push({
            "caption":_("dashboard_caption_configure", "Configure"),
            "icon":"fa-edit",
            "action":function(e){
                configure_dashboard(ko.unwrap(widget_model.settings)).then(function(new_settings) {
                    console.log("got new settings:", ko.toJS(new_settings));
                    widget_model.settings(new_settings);
                    uly.publish("page.savesettings");

                });
            },
            "colour":"default",
            "permission": "editpage"
        });
        var settings = ko.unwrap(widget_model.settings);
        widget_model.title(settings.title || _("dashboard_dashboard", "Dashboard"));
        widget_model.icon("fa fa-dashboard");
        var activate_first = settings.activate_first;
        widget_model.show_header(typeof settings.show_header === "undefined" ? true : settings.show_header);
        widget_model.show_header.subscribe(function(newvalue) {
            if (!newvalue)
                widget_model.panel_class(widget_model.panel_class().replace("box-primary", "box-no-header"));
            else
                widget_model.panel_class(widget_model.panel_class().replace("box-no-header", "box-primary"));
        });
        widget_model.show_header.notifySubscribers(widget_model.show_header());
        $(elt).parent().click(function(ev, ui) {
            if (ev.ctrlKey) {
                widget_model.show_header(!widget_model.show_header());
            }
        });
        var dashboard_model = {
            "active_cell": ko.observable(null),
            "active_tab": ko.observable(null),
            "tabs": ko.pureComputed(function() {
                var settings = ko.unwrap(widget_model.settings);
                var tabs = [];
                if (settings.tabs) {
                    tabs = settings.tabs;
                } else if (settings.rows) {
                    tabs = [{ "rows": settings.rows }];
                }

                return tabs.map((tab) => {
                    var newtab = {};
                    return Object.assign(newtab, {
                        "caption": tab.caption,
                        "icon": tab.icon,
                        "activate": () => { dashboard_model.active_tab(newtab); },
                        "rows": (tab.rows || []).map(function(row) {
                                var new_row = null;
                                var row_cells = [];
                                var total_width = 1;
                                if (row.cells) {
                                    total_width = row.cells.reduce((acc, c) => {
                                        console.log("acc:", acc, "c:", c, "res:", (1*acc) + 1*(c.columns && c.columns > 0 && c.columns <= 6 ? c.columns : 1));
                                        return (1*acc) + 1*(c.columns && c.columns > 0 && c.columns <= 6 ? c.columns : 1);
                                    }, 0);
                                    if (total_width >= 5) {
                                        total_width = 6;
                                    }
                                    new_row = {
                                        "is_growable": row.is_growable,
                                        "css_class": row.css_class || css_classes[total_width],
                                    };
                                    row_cells = row.cells;

                                } else {
                                    total_width = row.reduce((acc, c) => {
                                        console.log("acc:", acc, "c:", c, "res:", (1*acc) + 1*(c.columns && c.columns > 0 && c.columns <= 6 ? c.columns : 1));
                                        return (1*acc) + 1*(c.columns && c.columns > 0 && c.columns <= 6 ? c.columns : 1);
                                    }, 0);
                                    if (total_width >= 5) {
                                        total_width = 6;
                                    }

                                    new_row = {
                                        "is_growable": false,
                                        "css_class": css_classes[total_width]
                                    };
                                    row_cells = row;
                                }

                                new_row.get_css_class = (cell) => {
                                    console.log("Computing css_ class:", cell, new_row, cell.columns, total_width)
                                    if (!(cell && cell.columns ) || cell.columns === 1) {
                                        return new_row.css_class || css_classes[total_width];
                                    }
                                    var css = derived_classes[total_width][cell.columns];
                                    if (css) return css;
                                    return new_row.css_class || css_classes[total_width];
                                }

                                new_row.cells = row_cells.map(function(cell) {
                                        var new_cell = $.extend({
                                            "is_active": ko.observable(false),
                                            "search_settings": ko.observable(search_utils.ensure_settings_complete({})[0]),
                                            "ready": Promise.Deferred()
                                        }, cell);
                                        if (new_cell.class === "indicator")
                                            new_cell.class = "indicators";


                                        if (!new_cell.class)
                                            return null;
                                        $.extend(new_cell, {
                                            "activate_widget": function(data) {
                                                var new_val = !new_cell.is_active();
                                                if (data === true)
                                                    new_val = true;
                                                else if (data === false)
                                                    new_val = false;
                                                dashboard_model.search_active(false);
                                                new_cell.is_active(new_val);
                                                if (new_cell.is_active()) {
                                                    var old_cell = dashboard_model.active_cell();
                                                    if (old_cell && old_cell !== new_cell) {
                                                        old_cell.is_active(false);
                                                    }
                                                    dashboard_model.active_cell(new_cell);
                                                    //dashboard_model.search_active(true);
                                                } else if (dashboard_model.active_cell() === new_cell) {
                                                    dashboard_model.active_cell(null);
                                                    dashboard_model.search_active(false);
                                                }
                                            }
                                        });
                                        (function(new_cell) {
                                            new_cell.is_active.subscribe(function(newvalue) {
                                                if (newvalue) {
                                                    new_cell.ready.always(() => {
                                                        dashboard_model.search_settings(new_cell.search_settings());
                                                        dashboard_model.search_active(true);
                                                    });
                                                }
                                            });
                                        })(new_cell);
                                        return new_cell;
                            }).filter(function(cell) { return cell && cell.class });
                            return new_row;
                        })
                    });

                });
            }),
            "search_settings": ko.observable(search_utils.ensure_settings_complete({
                "navigable":false,
                "contextual":false,
                "filter":null,
                "parameters": { _search_body:null }
            })[0]),
            "search_active": ko.observable(false),
        };
        widget_model.dashboard_model = dashboard_model;
        dashboard_model.active_tab((dashboard_model.tabs() || [])[0] || {rows: []});
        dashboard_model.show_tabs = ko.pureComputed(() => dashboard_model.tabs().length > 1);

        dashboard_model.rows = ko.pureComputed(() => ko.unwrap(ko.unwrap(dashboard_model.active_tab) && ko.unwrap(dashboard_model.active_tab).rows) || []);
        widget_model.queue = {
            "items": [],
            "add_query": function(indicator, origin, path, extra_filter, extra_solr_filter) {
                var res = Promise.Deferred();
                var item = [{ "indicator": indicator, "origin": origin, "path": path, "extra_filter": extra_filter, "extra_solr_filter": extra_solr_filter }, res];
                this.items.push(item);
                var self = this;
                uly.utils.throttle(elt, function() {
                    self.execute();
                }, 500);
                return res.promise();
            },
            "execute": function() {
                var active_items = this.items;
                this.items = [];
                if (active_items.length > 0) {
                    uly.api.start().follow("uly:datasets").post("uly:results", {"method": "get", "items": ko.toJS(active_items.map(([item,def]) => item))}).then(function(results) {
                        active_items.map(([item, def], idx) => {
                            var result = results.results[idx];
                            if (result) {
                                def.resolve(result);
                            } else {
                                def.reject(null);
                            }
                        });
                    }).fail(function(results) {
                        active_items.forEach(function([item,def]) {
                            def.reject(results);
                        });
                    });
                }
            }
        };
        var child = context.createChildContext(widget_model);
        ko.applyBindingsToDescendants(child, elt);
        if (activate_first) {
            var found_indicator = false;
            dashboard_model.rows().forEach((row) => {
                row.cells.forEach((cell) => {
                    if (!found_indicator && cell.class === "indicators") {
                        found_indicator = true;
                        cell.activate_widget(true);
                    }
                });
            });
        }
        return { controlsDescendantBindings: true };
    }
};
uly.widgets.register({
    "type":"dashboard",
    "caption":_("dashboard_caption_dashboard", "Dashboard"),
    "description":_("dashboard_description_a_set_of_charts_and_indicators", "A set of charts and indicators"),
    "icon":"fa-dashboard",
    "init":function() {
        var data = {
            "title":null,
            "rows": [],
            "path": null,
            "filter": null
        };
        var init_def = Promise.Deferred();
        configure_dashboard(data).done(function(result) {
            result = ko.toJS(result);
            init_def.resolve(result);
        }).fail(init_def.reject);
        return init_def;
    },
    "colour":"olive"
});
